import styled from 'styled-components';

const HeaderList = styled.ul`
  margin-bottom: 0;
  margin-top: 0;
  text-align: left;
  display: inline-block;
  padding: 0;
`;

export default HeaderList;
